"use strict";

require("core-js/modules/es.array.for-each");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectUtils = /*#__PURE__*/function () {
  function ObjectUtils() {
    _classCallCheck(this, ObjectUtils);
  }

  _createClass(ObjectUtils, null, [{
    key: "objToString",

    /**
     * objToString function joins all the attributes of an object together using ` ` (space) as a glue
     * @param obj
     * @returns {string}
     */
    value: function objToString(obj) {
      var str = '';

      for (var p in obj) {
        if (obj.hasOwnProperty(p) && obj[p] !== null && obj[p] !== '') {
          str += "".concat(obj[p], " ");
        }
      }

      return str;
    }
    /**
     * Passes event data to the global dataLayer array which is passed to Google Tag Manager
     *
     * @param {Object} eventData - Key/value pairs for Google analytics
     * The keys are usually 'event', 'action' and the task
     */

  }, {
    key: "gaTrackingEvent",
    value: function gaTrackingEvent(eventData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    }
    /**
     *
     * @param {*} eventDataArray
     * @returns
     */

  }, {
    key: "gaTrackingArrayEvents",
    value: function gaTrackingArrayEvents(eventDataArray) {
      try {
        if (!Array.isArray(eventDataArray)) {
          return false;
        }

        window.dataLayer = window.dataLayer || [];
        eventDataArray.forEach(function (eventItem) {
          window.dataLayer.push(eventItem);
        });
        return true;
      } catch (err) {
        console.error('Could not push data to GA dataLayer');
        return false;
      }
    }
  }]);

  return ObjectUtils;
}();

exports.default = ObjectUtils;
//# sourceMappingURL=ObjectUtils.js.map